import React from "react";
import {EvacuadosPorSector as EvacuadosPorSectorContainer} from '../../../containers/EvacuadosPorSector'
import { CAMPAIGN_2026 } from '../../../constants';

const EvacuadosPorSector = () => {
  return <EvacuadosPorSectorContainer campaign={CAMPAIGN_2026} year={2026}/>
};

export default EvacuadosPorSector;
